/* Copyright (c) 2024 Xperi. All Rights Reserved. */

// eslint-disable-next-line no-shadow
export enum TransitionScreenType {
    MYSHOWS = 'myshows',
    ONEPASS_MANAGER = 'onepassManager',
    COLLECTION_SCREEN = 'collectionScreen',
    GALLERY_SCREEN = 'galleryScreen',
    HOMESCREEN = 'homeScreen',
}
